import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-primary text-primary-foreground">
      <div className="mx-auto max-w-[1600px] px-6 lg:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-6">
            <div className="font-display text-4xl md:text-6xl font-extrabold tracking-tighter leading-none">
              Let's build the<br />next landmark.
            </div>
          </div>
          <div className="md:col-span-3">
            <div className="overline text-primary-foreground/50 mb-4">Studio</div>
            <p className="text-sm leading-relaxed text-primary-foreground/80">
              Rubino Real Estate<br />Grev Turegatan 10<br />113 46 Stockholm, Sweden
            </p>
          </div>
          <div className="md:col-span-3">
            <div className="overline text-primary-foreground/50 mb-4">Enquiries</div>
            <p className="text-sm leading-relaxed text-primary-foreground/80">
              Harry Rubino<br />harry@rubino.se<br />+46 733 76 39 30
            </p>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-primary-foreground/15 flex flex-col md:flex-row justify-between gap-4 text-xs text-primary-foreground/50">
          <span>© {new Date().getFullYear()} Rubino Real Estate. All rights reserved.</span>
          <Link to="/login" data-testid="footer-admin-link" className="link-underline">Admin</Link>
        </div>
      </div>
    </footer>
  );
}
